import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import {
  ServicioNotificacionDevolucionMedicamentosService, ParametrosNotificacionDevolucionMedicamentosEntity, EntidadEmpresarial
} from 'src/app/services/servicio-notificacion-devolucion-medicamentos.service';
import { HttpErrorResponse } from '@angular/common/http';
import { FileService } from 'src/app/services/utils/file.service';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-header-notificacion-devolucion-medicamentos',
  templateUrl: './header-notificacion-devolucion-medicamentos.component.html',
  styleUrls: ['./header-notificacion-devolucion-medicamentos.component.css']
})
export class HeaderNotificacionDevolucionMedicamentosComponent implements OnInit {

  fechaInicial: Date;
  fechaFinal: Date;
  loading: boolean;
  downloading: boolean;
  canDownload: boolean;
  tablas: any;
  mensajeError: string; // Mensaje de error

  @Input() public objetoParametrosEntity: ParametrosNotificacionDevolucionMedicamentosEntity;
  @Output() entidadEmpresarial: EventEmitter<any>;

  constructor(private servicioNotificacionDevolucionMedicamentosService: ServicioNotificacionDevolucionMedicamentosService,
    private servicioArchivo: FileService
    ) {
    this.loading = true;
    this.entidadEmpresarial = new EventEmitter();
  }

  ngOnInit() {
    this.getEntidadEmpresarial();
  }

  async getEntidadEmpresarial() {

    try {

      const response = await this.servicioNotificacionDevolucionMedicamentosService.getEntidadEmpresarial(
        this.objetoParametrosEntity.codigoBaseDatos, this.objetoParametrosEntity.uncoEntidad);

      if (response != null) {
        response.subscribe((data: any) => {

          const entidad: EntidadEmpresarial = {
            unco: data.unco,
            nombreEntidad: data.dscrpcn_entdd_emprsrl,
            nit: data.idntfccn_trbtra,
            digitoVerificacion: data.dgto_vrfccn,
            direccion: data.drccn,
            telefono: data.tlfno_pbx,
          };

          this.entidadEmpresarial.emit(entidad);

        }, (err: HttpErrorResponse) => {
          console.error('Error sede', err);
          if (err.status === 500)
            this.loading = false;
          else
            console.error('Error en datos entidad empresarial: ' + JSON.stringify(err));
        });
      }
    } catch (e) {
      console.error(e);
    }
  }

  onGenerar() {
    this.canDownload = true;
    this.entidadEmpresarial.emit(null);
  }

  mostrarMensaje(mensaje: string) {
    this.mensajeError = mensaje;
    setTimeout(() => {
      this.mensajeError = null;
    }, 5000);
  }

  onDescargarPDF() {

    this.downloading = true;
    document.getElementById('notificacion-print').style.width = '125%';
    document.getElementById('notificacion-print').style.fontSize = '13px';
    this.tablas = document.getElementsByTagName('table');
    for (const iterator of this.tablas) {
      iterator.style.fontSize = '13px';
    }
    try {

        const dataPagina = xepOnline.Formatter.Html('notificacion-print', { resolution: '200' });
        const html = `<html><head><meta charset="UTF-8"/></head><body>${dataPagina}</body></html>`;
        const response = this.servicioArchivo.generatePDF(html, 'Notificacion devolucion medicamentos ', 'Notificacion-devolucion-medicamentos');
        if (response != null) {
          response.subscribe((data: any) => {
            const filename = data.filename;
            this.servicioArchivo.downloadFile(filename)
              .subscribe((dataTemp) => {
                saveAs(dataTemp, filename);
                this.downloading = false;
              }, err => {
                this.mostrarMensaje('Error al intentar generar PDF, reporte caso inmediatamente a su administrador.');
                console.error('Error download', err);
                this.downloading = false;
              });
          }, (err: HttpErrorResponse) => {
            console.error('Error', err);
            this.mostrarMensaje('La generación PDF no se encuentra funcionando, reporte caso inmediatamente a su administrador.');
            this.downloading = false;
          });
        } else {
          console.error('Response Null');
        }
        this.downloading = false;

      document.getElementById('notificacion-print').style.fontSize = '16px';
      this.tablas = document.getElementsByTagName('table');
      for (const iterator of this.tablas) {
        iterator.style.fontSize = '16px';
      }
      document.getElementById('notificacion-print').style.width = '100%';
    } catch (e) {
      this.mostrarMensaje('Error al intentar generar archivo pdf, reporte caso al administrador');
      this.downloading = false;
      console.error(e);
    }

  }

}
